import { Injectable } from '@angular/core';

@Injectable()
export class ProcedureInstanceLocalStorageService {
  private readonly storageKey = 'procedureInstances';

  constructor() {}

  public save(
    procedureInstanceId: number,
    instance: ProcedureInstanceLocalStorageDto
  ): void {
    const storedInstances = JSON.parse(
      localStorage.getItem(this.storageKey) || '{}'
    ) as Record<number, ProcedureInstanceLocalStorageDto>;

    storedInstances[procedureInstanceId] = instance;

    localStorage.setItem(this.storageKey, JSON.stringify(storedInstances));
  }

  public get(
    procedureInstanceId: number
  ): ProcedureInstanceLocalStorageDto | null {
    const instances = JSON.parse(
      localStorage.getItem(this.storageKey) || '{}'
    ) as Record<number, ProcedureInstanceLocalStorageDto>;

    return instances[procedureInstanceId] ?? null;
  }
}

export class ProcedureInstanceLocalStorageDto {
  serviceKey: string;
  procedureInstanceId: number;
  procedureInstanceNumber: string;
}
